interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionTo?: string;
  actionLabel?: string;
}

import { Link } from 'react-router-dom';

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionTo,
  actionLabel,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="inline-block text-xs font-medium uppercase tracking-[0.28em] text-accent-600">
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 text-sm text-foreground-600">{desc}</p>}
      </div>
      {actionTo && actionLabel && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1 text-sm text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}